import React, { Component, useEffect, useState } from "react";
import RegisterForm from "../../..//registerForm";
import { Link } from "react-router-dom";
import CustomButton from "../../../../../../../components/customButton";
import { useHistory, withRouter } from "react-router-dom/";
import welcomePanda from "../../../../../../../assets/img/welcome-panda.png";
import StoreButtons from "../../../../../../../components/storeButtons";

const Welcome = () => {
  const history = useHistory();
  const [language, setLanguage] = useState("");
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const languages = [
      "Professional Career",
      "Management",
      "Entrepreneurship",
      "Sales",
      "Marketing",
      // "Design",
      "IT & AI",
      "Personal Development",
    ];

    let newLanguage = "";
    for (let i = 0; i < languages[index].length; i++) {
      (function (i) {
        setTimeout(function () {
          newLanguage += languages[index][i];
          setLanguage(newLanguage);
          if (i === languages[index].length - 1) {
            setTimeout(() => {
              setIndex(index === languages.length - 1 ? 0 : index + 1);
            }, 2000);
          }
        }, 200 * i);
      })(i);
    }
  }, [index]);

  // useEffect(() => {
  //   changeLanguage(index);
  // }, []);

  return (
    <section id="home">
      <div className="container">
        <div className="col col-6">
          <div className="banner_text">
            <h1>
              With Duomly you can
              <br />
              learn <span>{language}</span>
              <br />
              like never before!
            </h1>
            <p>
              Chart Your Path in Entrepreneurship, AI & ChatGPT, Management,
              Marketing, Sales, and Personal Development with Our Interactive
              Courses.
            </p>
          </div>
          <div className="text-center md:float-left mt-4">
            <StoreButtons />
          </div>
        </div>
        <div className="col col-6 right flex flex-row justify-center mt-8 md:mt-0">
          {/* Iphone with app screen */}
          <img src={welcomePanda} />
          {/* <RegisterForm /> */}
        </div>
      </div>
      <div id="particles-js"></div>
      <div className="wave"></div>
    </section>
  );
};

export default Welcome;
